import { NgModule } from "@angular/core";
import { BarcodesVerificationFormComponent } from './barcodes-verification-form/barcodes-verification-form.component';
import { DynamicBarcodesVerificationComponent } from './dynamic-barcodes-verification.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { BarcodesVerificationDesignComponent } from './barcodes-verification-design/barcodes-verification-design.component';
import { BarcodesVerificationResultComponent } from './barcodes-verification-result/barcodes-verification-result.component';
import { MaterialModule } from 'src/app/shared/material.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { BarcodesVerificationService } from './barcodes-verification.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CodeScannerModule } from '../../code-scanner/code-scanner.module';
import { FamocoScanLaserModule } from '../../famoco-scan-laser/famoco-scan-laser.module';

@NgModule({
    declarations: [
        BarcodesVerificationResultComponent,
        BarcodesVerificationDesignComponent,
        BarcodesVerificationFormComponent, DynamicBarcodesVerificationComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MatIconModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        CodeScannerModule,
        FamocoScanLaserModule
    ],
    entryComponents: [
        DynamicBarcodesVerificationComponent
    ],
    providers: [
        BarcodesVerificationService
    ]
})
export class BarcodesVerificationModule {}